"use client";

import { useEffect, type RefObject } from "react";

/**
 * Syncs `--login-vvh` to VisualViewport height so the login shell tracks the
 * visible area when the mobile keyboard opens (iOS overlay behavior).
 */
export function useLoginViewportHeight(
  shellRef: RefObject<HTMLElement | null>
): void {
  useEffect(() => {
    const shell = shellRef.current;
    const viewport = window.visualViewport;
    if (!shell || !viewport) return;

    const sync = () => {
      shell.style.setProperty("--login-vvh", `${viewport.height}px`);
    };

    sync();
    viewport.addEventListener("resize", sync);
    viewport.addEventListener("scroll", sync);

    return () => {
      viewport.removeEventListener("resize", sync);
      viewport.removeEventListener("scroll", sync);
      shell.style.removeProperty("--login-vvh");
    };
  }, [shellRef]);
}
